import {
  CSSObject,
  Theme,
  getFontWeight,
  forBrands,
} from '@core-ui/react-stitch';

export const getFullHexColor = (hex: string, transparency?: string) => {
  const fullHexColor = hex.length < 5 ? hex + hex.substring(1) : hex;
  return transparency ? fullHexColor + transparency : fullHexColor;
};

const setOptionStyleForBananaRepublic = (theme: Theme): CSSObject => ({
  color: theme.color.b2,
  backgroundColor: theme.color.inverse.b1,
  fontWeight: getFontWeight('regular').fontWeight,
  fontSize: '1rem',
  '&:hover': {
    backgroundColor: theme.color.wh,
  },
  '&[aria-selected="true"]': {
    backgroundColor: getFullHexColor(theme.color.b1, '1A'),
  },
});

const getOptionStyles =
  () =>
  (base: CSSObject, { theme }: { theme: Theme }): CSSObject => ({
    ...base,
    ...(forBrands(theme, {
      br: setOptionStyleForBananaRepublic,
      brfs: setOptionStyleForBananaRepublic,
    }) as CSSObject),
  });

export default getOptionStyles;
